// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"435":"62835784","787":"472e62d9","827":"cbf15898"}[chunkId] + ".chunk.js";
};